// export const baseUrl = "https://nodetest.lighthouse.storage";
export const baseUrl: string = "https://api.lighthouse.storage";
export const encryptedBaseUrl: string = "https://encryption.lighthouse.storage";
export const decryptPageURL: string = "https://files.lighthouse.storage/viewFile";
